import {Component, Input} from '@angular/core';
import {NavItem} from '../../../../models/nav-item.model';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
})
export class DashboardComponent {
    @Input() items: NavItem[] = [];
}
